import {Menu, X} from 'lucide-react'
import { useState } from 'react'

const NAV_LINKS = [
  { label: 'Что это', href: '#what' },
  { label: 'Услуги', href: '#services' },
  { label: 'Преимущества', href: '#advantages' },
  { label: 'Кейсы', href: '#cases' },
  { label: 'Контакты', href: '#contact' },
]

function Header() {
  const [isOpen, setIsOpen] = useState(false)

  const handleNavClick = () => setIsOpen(false)

  return (
    <header className="sticky top-0 z-50 border-b border-neutral-800 bg-neutral-950/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="#top" className="flex items-center gap-2 text-lg font-black tracking-tight text-white">
          SEO<span className="text-emerald-400">/</span>GEO
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map(link => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-neutral-400 transition-colors hover:text-white"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#contact"
            className="rounded-full bg-emerald-400 px-4 py-2 text-sm font-semibold text-neutral-950 transition-colors hover:bg-emerald-300"
          >
            Оставить заявку
          </a>
        </div>

        <button
          type="button"
          onClick={() => setIsOpen(prev => !prev)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-neutral-800 text-neutral-200 md:hidden"
          aria-label="Открыть меню"
        >
          {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {isOpen ? (
        <div className="border-t border-neutral-800 bg-neutral-950 px-4 pb-6 pt-2 md:hidden">
          <nav className="flex flex-col gap-1">
            {NAV_LINKS.map(link => (
              <a
                key={link.href}
                href={link.href}
                onClick={handleNavClick}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-neutral-300 transition-colors hover:bg-neutral-900 hover:text-white"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={handleNavClick}
              className="mt-2 rounded-full bg-emerald-400 px-4 py-2.5 text-center text-sm font-semibold text-neutral-950"
            >
              Оставить заявку
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  )
}

export default Header
